'use client';

import { AdSlot } from '@/app_components/AdSlot/Adslot';
import { useAdContext } from '@/app_lib/providers/AdProvider';
import { usePaywall } from '@/app_lib/providers/PaywallProvider';
import { useStickyFooter } from '@/app_lib/providers/StickyFooterProvider';
import { ContentPlacement } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';

interface StickyFooterProps {
  index: number;
}

export const StickyFooter = ({ index }: StickyFooterProps) => {
  const { pageAdConfig } = useAdContext();
  const { showPaywallax } = usePaywall();
  const { renderStickyFooter } = useStickyFooter();

  return renderStickyFooter && !showPaywallax ? (
    <div
      className={cn(
        'justify-center items-center sticky min-h-[60px] z-body-overlay transition-[height] duration-500 ease-in-out bottom-0 bg-white w-full flex',
      )}
      data-cy={ContentPlacement.StickyFooter}
    >
      {pageAdConfig && (
        <AdSlot
          index={index + 1}
          placementName='StickyFooter'
          sticky={true}
        />
      )}
    </div>
  ) : null;
};
